import axios from 'axios';
import axiosInstance from '../axiosInstance';

export const getJobFeed = async () => {
  const response = await axiosInstance.get('/job/post/feed');
  return response.data.data;
};

export const getJobPosts = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/job/post', { params });
    return response.data.data;
  } catch (error) {
    console.error('Get Job Posts API Error:', error);
    throw error;
  }
};

export const getJobBoardScreenData = async () => {
  try {
    const response = await axiosInstance.get('/job/board');
    return response.data.data;
  } catch (error) {
    console.error('Get JobBoard Screen API Error:', error);
    throw error;
  }
};

export const createJobPost = async (data) => {
  try {
    const response = await axiosInstance.post('/job/post', data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data.data;
  } catch (error) {
    console.error('Create Job Post API Error:', error);
    throw error;
  }
};

export const getJobPostOptions = async () => {
  try {
    const response = await axiosInstance.get('/job/post/options');
    return response.data.data;
  } catch (error) {
    console.error('Get Job Post Options API Error:', error);
    throw error;
  }
};

export const getJobPostLogoUploadUrl = async (fileName) => {
  const response = await axiosInstance.post('/job/post/logo/upload-url', null, {
    params: { fileName },
  });
  return response.data.data;
};

export const uploadJobPostLogoToS3 = async (file, uploadUrl) => {
  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });
};

export const getJobPostDetail = async (jobPostId) => {
  try {
    const response = await axiosInstance.get(`/job/post/${jobPostId}`);
    return response.data.data;
  } catch (error) {
    console.error('Get Job Post Detail API Error:', error);
    throw error;
  }
};

export const updateJobPost = async (jobPostId, data) => {
  try {
    const response = await axiosInstance.put(`/job/post/${jobPostId}`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data.data;
  } catch (error) {
    console.error('Update Job Post API Error:', error);
    throw error;
  }
};

export const deleteJobPost = async (jobPostId) => {
  try {
    const response = await axiosInstance.delete(`/job/post/${jobPostId}`);
    return response.data.data;
  } catch (error) {
    console.error('Delete Job Post API Error:', error);
    throw error;
  }
};

export const deleteJobPostPermanent = async (jobPostId) => {
  try {
    const response = await axiosInstance.delete(
      `/job/post/${jobPostId}/permanent`
    );
    return response.data.data;
  } catch (error) {
    console.error('Delete Job Post Permanently API Error:', error);
    throw error;
  }
};

export const hideJobPost = async (jobPostId) => {
  try {
    const response = await axiosInstance.put(`/job/post/${jobPostId}/hide`);
    return response.data.data;
  } catch (error) {
    console.error('Hide Job Post API Error:', error);
    throw error;
  }
};

export const unhideJobPost = async (jobPostId) => {
  try {
    const response = await axiosInstance.put(`/job/post/${jobPostId}/unhide`);
    return response.data.data;
  } catch (error) {
    console.error('Unhide Job Post API Error:', error);
    throw error;
  }
};

export const closeJobPost = async (jobPostId) => {
  try {
    const response = await axiosInstance.put(`/job/post/${jobPostId}/close`);
    return response.data.data;
  } catch (error) {
    console.error('Close Job Post API Error:', error);
    throw error;
  }
};

export const saveDraftJobPost = async (jobPostId) => {
  try {
    const response = await axiosInstance.put(
      `/job/post/${jobPostId}/savedraft`
    );
    return response.data.data;
  } catch (error) {
    console.error('Save Draft Job Post API Error:', error);
    throw error;
  }
};

export const bookmarkJobPost = async (jobPostId) => {
  try {
    const response = await axiosInstance.post(
      `/job/post/${jobPostId}/bookmark`
    );
    return response.data.data;
  } catch (error) {
    console.error('Bookmark Job Post API Error:', error);
    throw error;
  }
};

export const unbookmarkJobPost = async (jobPostId) => {
  try {
    const response = await axiosInstance.delete(
      `/job/post/${jobPostId}/bookmark`
    );
    return response.data.data;
  } catch (error) {
    console.error('Unbookmark Job Post API Error:', error);
    throw error;
  }
};

export const hideJobPostForUser = async (jobPostId) => {
  try {
    const response = await axiosInstance.post(`/job/post/${jobPostId}/hidden`);
    return response.data.data;
  } catch (error) {
    console.error('Hide Job Post For User API Error:', error);
    throw error;
  }
};

export const deleteMultipleBookmarks = async (jobPostIds) => {
  try {
    const response = await axiosInstance.delete('/job/post/bookmarks', {
      data: jobPostIds,
    });
    return response.data.data;
  } catch (error) {
    console.error('Delete Multiple Bookmarks API Error:', error);
    throw error;
  }
};

export const unhideJobPostForUser = async (jobPostId) => {
  try {
    const response = await axiosInstance.delete(
      `/job/post/${jobPostId}/hidden`
    );
    return response.data.data;
  } catch (error) {
    console.error('Unhide Job Post For User API Error:', error);
    throw error;
  }
};

export const getMyBookmarkedJobPosts = async () => {
  try {
    const response = await axiosInstance.get('/job/post/me/bookmarks');
    return response.data.data;
  } catch (error) {
    console.error('Get My Bookmarked Job Posts API Error:', error);
    throw error;
  }
};

export const getMyHiddenJobPosts = async () => {
  try {
    const response = await axiosInstance.get('/job/post/me/hidden');
    return response.data.data;
  } catch (error) {
    console.error('Get My Hidden Job Posts API Error:', error);
    throw error;
  }
};

const toCreateRequestFromDetail = (detail, overrides = {}) => ({
  title: detail.title,
  companyName: detail.companyName,
  companyLogoUrl: detail.companyLogoUrl,
  location: detail.location,
  companyAddress: detail.companyAddress,
  companyAddressDetail: detail.companyAddressDetail,
  roleOptionItemId: detail.roleOptionItemId,
  roleCustomText: detail.roleCustomText,
  employmentTypeOptionItemId: detail.employmentTypeOptionItemId,
  workingScheduleOptionItemId: detail.workingScheduleOptionItemId,
  workingScheduleDetailOptionItemId: detail.workingScheduleDetailOptionItemId,
  workTime: detail.workTime,
  workingDays: detail.workingDays,
  salaryTypeOptionItemId: detail.salaryTypeOptionItemId,
  amountMin: detail.amountMin,
  amountMax: detail.amountMax,
  currencyOptionItemId: detail.currencyOptionItemId,
  currencyCustomText: detail.currencyCustomText,
  visaSponsorship: detail.visaSponsorship,
  koreaResidentsOnly: detail.koreaResidentsOnly,
  koreanSkillLevelOptionItemId: detail.koreanSkillLevelOptionItemId,
  topikRequirementOptionItemId: detail.topikRequirementOptionItemId,
  topikRequirementLevelOptionItemId: detail.topikRequirementLevelOptionItemId,
  topikSpeakingRequirementOptionItemId:
    detail.topikSpeakingRequirementOptionItemId,
  topikSpeakingLevelOptionItemId: detail.topikSpeakingLevelOptionItemId,
  nationalityOptionItemId: detail.nationalityOptionItemId,
  nationalityCustomText: detail.nationalityCustomText,
  careerLevelOptionItemId: detail.careerLevelOptionItemId,
  aboutRole: detail.aboutRole,
  detailInfo: detail.detailInfo,
  perks: detail.perks,
  benefits: detail.benefits,
  applicationDeadline: detail.applicationDeadline,
  hiringStatus: detail.hiringStatus,
  startAvailabilityOptionItemId: detail.startAvailabilityOptionItemId,
  startAvailabilityCustomText: detail.startAvailabilityCustomText,
  portfolioSubmission: detail.portfolioSubmission,
  resumeRequired: detail.resumeRequired,
  responseSpeedOptionItemId: detail.responseSpeedOptionItemId,
  status: detail.status,
  publishedAt: detail.publishedAt,
  visaTypeOptionItemIds: detail.visaTypeOptionItemIds ?? [],
  requiredLanguages: detail.requiredLanguages ?? [],
  ...overrides,
});

export const changeJobPostStatus = async (jobPostId, status) => {
  const detail = await getJobPostDetail(jobPostId);
  const overrides = { status };
  if (status === 'ACTIVE' && !detail.publishedAt) {
    overrides.publishedAt = new Date().toISOString();
  }
  return updateJobPost(jobPostId, toCreateRequestFromDetail(detail, overrides));
};

export const duplicateJobPost = async (jobPostId) => {
  const detail = await getJobPostDetail(jobPostId);
  const duplicatedTitle = `${detail.title} (Copy)`;
  return createJobPost(
    toCreateRequestFromDetail(detail, {
      title: duplicatedTitle,
      status: 'DRAFT',
      publishedAt: null,
    })
  );
};

export const getJobBoardCategories = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/job/category', {
      params,
    });
    return response.data.data;
  } catch (error) {
    console.error('Get JobBoard Categories API Error:', error);
    throw error;
  }
};

export const getMyHiddenJobPostsList = async () => {
  try {
    const response = await axiosInstance.get('/job/post/hidden/all');
    return response.data.data;
  } catch (error) {
    console.error('Get My Hidden Job Posts API Error:', error);
    throw error;
  }
};

export const getMyBookmarks = async (period = 'ALL', page = 0, size = 7) => {
  try {
    const params = { page, size };
    if (period !== 'ALL') params.period = period;

    const res = await axiosInstance.get('/job/board/bookmarks/me', { params });
    return res.data.data;
  } catch (error) {
    console.error('Get My Bookmark Job Posts API Error:', error);
    throw error;
  }
};
